/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import React, { useCallback, useState } from 'react';
import { Button } from '../common';
import { MapLobbiesImg } from '../../constants/maps';
import { MapsTemp } from '../../game-engine/maps-utils/map-functions-temp';
import $ from 'jquery';
import { joinTournament, toMiliSTX } from '../../auth';
import { LoadingState, LobbyStatus } from './LobbiesList';

// import privacyPublic from './resources/Privacy/Public.png';
import newTabTx from './resources/new-tab.svg';
import newTabTxWhite from './resources/new-tab-white.svg';
import { transactionUrl, UrlType } from '../../constants/transactionUrl';
import { network } from '../../constants/network';
import { contractMapping } from '../../constants/contract';
import { RaceShell } from '../elements/RaceShell';
import { link_comp } from '../../game-engine/maps-utils/constants';
import { OpenState } from './CreateLobby';
import { RowData } from '../../types';
import { createLobbyRowData } from '../../utils';
import { DialogHighscores, ServerData } from '../highscores/DialogHighscores';
import { apiMapping } from '../../constants/apiUrl';

const styleProps = css`
  width: 46%;
  display: inline-block;
  margin-bottom: 20px;
  & .lobby-card-container {
    width: 100%;
    display: flex;
    background: #7530e3;
    border-radius: 10px;
    overflow: hidden;
    & .lobby-card-actions {
      display: flex;
      justify-content: flex-end;
      flex-flow: column;
      width: 45%;
      float: left;
      background-size: 130%;
      background-position: 50% 62%;
      background-repeat: no-repeat;
      padding-bottom: 3px;

      & .btn {
        align-self: flex-end;
        margin: 3px auto;
        transition: all 0s !important;
      }
      @media (max-width: 1399px) {
        background-size: 150%;
        background-position: 50% 0%;
      }
      @media (max-width: 1199px) {
        background-size: 150%;
        background-position: 50% 50%;
      }
      @media (max-width: 991px) {
        background-position: 50% 48%;
      }
    }
    & .lobby-card-details {
      width: 55%;
      display: inline-block;
      float: right;
      padding: 20px 20px;
      box-sizing: border-box;
      text-align: center;

      & span {
        display: block;
        line-height: 20px;
      }
    }
  }
  @media (max-width: 991px) {
    width: 100%;
  }
`;

export function getTxIdUrl(txId: string, urlType: UrlType) {
  return transactionUrl[network](txId)[urlType];
}

export interface ILobbyTxId {
  txId: string;
  urlType: UrlType;
  imgSrc: string;
  imgWidth: string;
}

export const LobbyTxId = ({ txId, urlType, imgSrc, imgWidth }: ILobbyTxId) => {
  return (
    <span>
      <a target={'_blank'} href={getTxIdUrl(txId, urlType)}>
        <img src={imgSrc} alt="" width={imgWidth} />
      </a>
    </span>
  );
};

export type LobbyCardStatus =
  | 'checking'
  | 'created'
  | 'createdJoined'
  | 'createdChecking'
  | 'createdReadyToStart'
  | 'started'
  | 'startedReady'
  | 'startedChecking'
  | 'ended'
  | 'refunded'
  | 'failed';

export interface ILobbyCardPaidProp {
  // for ended & refunded lobbies will display it
  status: LobbyCardStatus;
  paid: boolean;
}

const isNegativeTime = (timeLeftState: string): boolean => {
  return timeLeftState.indexOf('-') > -1;
};

export interface ILobbyCardTimeProps {
  createTime: string;
  endTime: string;
  status: LobbyCardStatus;
  timeLeft: string;
  setTimeLeft: React.Dispatch<React.SetStateAction<string>>;
}

export const LobbyCardTime = (props: ILobbyCardTimeProps) => {
  const timeStatus = ['checking'].includes(props.status)
    ? 'createTime'
    : ['created', 'createdJoined', 'createdChecking', 'createdReadyToStart'].includes(props.status)
    ? 'remainingTime'
    : ['started', 'startedReady', 'startedChecking'].includes(props.status)
    ? 'remainingTime'
    : ['ended'].includes(props.status)
    ? 'endTime'
    : ['refunded'].includes(props.status)
    ? 'endTime'
    : ['failed'].includes(props.status)
    ? 'createTime'
    : '';

  const calculateTimeLeft = (endTime: string) => {
    let difference = +new Date() - +new Date(endTime);

    let timeLeft = '',
      days = Math.floor(difference / (1000 * 60 * 60 * 24)) + 1;
    timeLeft =
      (days ? -days + ' days ' : '') +
      -Math.floor(((difference / (1000 * 60 * 60)) % 24) + 1) +
      ':' +
      (Math.floor((difference / 1000 / 60) % 60) > -10 ? '0' : '') +
      -Math.floor(((difference / 1000 / 60) % 60) + 1) +
      ':' +
      (Math.floor((difference / 1000) % 60) > -10 ? '0' : '') +
      -Math.floor((difference / 1000) % 60);

    return timeLeft;
  };

  React.useEffect(() => {
    if (timeStatus === 'remainingTime') {
      props.setTimeLeft(calculateTimeLeft(props.endTime));

      const timer = setInterval(() => {
        props.setTimeLeft(calculateTimeLeft(props.endTime));
      }, 1000);

      // TODO(andrei): Check that this is not a memory leak when the component is destroyed
      return () => clearInterval(timer);
    }
  }, [props.createTime, props.timeLeft]);

  const [timeLobby, setTimeLobby] = React.useState<string>('');
  React.useEffect(() => {
    let date = timeStatus === 'createTime' ? props.createTime : timeStatus === 'endTime' ? props.endTime : '';

    if (date.length)
      setTimeLobby(
        // TODO(andrei): Maybe extract this to a constants folder/file
        new Intl.DateTimeFormat('en-GB', {
          year: 'numeric',
          month: 'numeric',
          day: '2-digit',
          hour: 'numeric',
          minute: 'numeric',
          second: 'numeric',
        }).format(new Date(date))
      );
  }, [props.status]);

  return (
    <span>
      {timeStatus === 'createTime' ? (
        <>
          Created Time
          <br />
          {timeLobby}
        </>
      ) : timeStatus === 'remainingTime' && !isNegativeTime(props.timeLeft) ? (
        <>
          Remaining Time
          <br />
          {props.timeLeft}
        </>
      ) : timeStatus === 'remainingTime' ? (
        <>
          Ended
          <br />
          Waiting on block
        </>
      ) : timeStatus === 'endTime' ? (
        <>
          Ended Time
          <br />
          {timeLobby}
        </>
      ) : (
        ''
      )}
    </span>
  );
};

export interface ILobbyCardProps {
  data: any;
  accountAddress: string;
  updateRaceLobbyProps: (arg: any) => void;
  setLoadingState: React.Dispatch<React.SetStateAction<LoadingState>>;
  setOpenState: React.Dispatch<React.SetStateAction<OpenState>>;
  onClickRace: () => void;
  handleRefetch: (callback?: () => void) => void;
  setLobbiesStatus: (status: LobbyStatus) => void;
}

export const LobbyCard = (props: ILobbyCardProps) => {
  const [isRacing, setIsRacing] = useState(false);

  let owner = props.data.owner
    ? props.data.owner.slice(0, 4) +
      '...' +
      props.data.owner.slice(props.data.owner.length - 4, props.data.owner.length)
    : '';

  const sendDbJoinLobby = () => {
    const userDt = localStorage.getItem('userData');
    if (userDt == null) return;
    const address = JSON.parse(userDt);

    $.post(link_comp + '/join-lobby', { address: address, idLobby: props.data.idLobby }, () => {
      props.setLoadingState('SuccessfulJoin');
      props.handleRefetch();
    }).fail((xhr) => {
      props.setLoadingState('FailedJoin');
    });
  };

  const setCancelState = () => {
    props.setLoadingState('CanceledJoin');
  };

  const sendDbStartLobby = () => {
    const userDt = localStorage.getItem('userData');
    if (userDt == null) return;
    const address = JSON.parse(userDt);

    $.post(link_comp + '/start-lobby', { address: address, idLobby: props.data.idLobby }, () => {
      props.setLoadingState('SuccessfulStart');
      props.handleRefetch(() => {
        props.setLobbiesStatus('started');
      });
    }).fail((xhr) => {
      props.setLoadingState('FailedStart');
    });
  };

  const refundedBtnText = () => {
    const paidMessage = props.data.paid === true ? 'Refunded' : props.data.paid === false ? 'Refunding...' : 'Invalid';
    return paidMessage;
  };

  const paydEndedBtnText = () => {
    const paidMessage = props.data.paid === true ? 'Ended' : props.data.paid === false ? 'Pending...' : 'Invalid';
    return paidMessage;
  };

  const onClickStart = () => {
    if (isNegativeTime(timeLeft)) {
      return;
    }
    props.setLoadingState('LoadingStart');
    sendDbStartLobby();
  };

  const onClickRace = () => {
    if (isNegativeTime(timeLeft)) {
      return;
    }
    // props.updateRaceLobbyProps(props.data);
    // props.onClickRace();

    setIsRacing(true);
  };

  const [timeLeft, setTimeLeft] = React.useState<string>('...');

  const onJoinLobby = () => {
    props.setOpenState(true);
    if (isNegativeTime(timeLeft)) {
      return;
    }
    joinTournament({
      id: props.data.idLobby,
      price: props.data.price,
      onFinish: sendDbJoinLobby,
      onCancel: setCancelState,
    });
    props.setLoadingState('LoadingJoin');
  };

  const areHighscoresLobby = (highscores: ServerData[]): boolean => {
    if (highscores.length === 0) return false;
    if (highscores.length === 1 && highscores[0].score == -1) return false;
    return true;
  };

  // dataset for highscores
  // const rows: RowData[] = [
  //   createData(1, 'SP1SCEXE6PMGPAC6B4N5P2MDKX8V4GF9QDE1FNNGJ', 'MiamiDegen#123', 6.0124),
  //   createData(2, 'SP1SCEXE6PMGPAC6B4N5P2MDKX8V4GF9QDE1FAAAA', 'MiamiDegen#534', 9.7453),
  //   createData(3, 'SP1SCEXE6PMGPAC6B4N5P2MDKX8V4GF9QDE1FBBBB', 'MiamiDegen#76', 16.645),
  //   createData(4, 'SP1SCEXE6PMGPAC6B4N5P2MDKX8V4GF9QDE1FCCCC', 'NYCDegen#69', 4.3775),
  //   createData(5, 'SP1SCEXE6PMGPAC6B4N5P2MDKX8V4GF9QDE1FDDDD', 'NYCDegen#420', 16.9302),
  //   createData(6, 'SP1SCEXE6PMGPAC6B4N5P2MDKX8V4GF9QDE1FNNGJ', 'MiamiDegen#123', 6.0124),
  //   createData(7, 'SP1SCEXE6PMGPAC6B4N5P2MDKX8V4GF9QDE1FAAAA', 'MiamiDegen#534', 9.7453),
  //   createData(8, 'SP1SCEXE6PMGPAC6B4N5P2MDKX8V4GF9QDE1FBBBB', 'MiamiDegen#76', 16.645),
  //   createData(9, 'SP1SCEXE6PMGPAC6B4N5P2MDKX8V4GF9QDE1FCCCC', 'NYCDegen69', 4.3775),
  //   createData(10, 'SP1SCEXE6PMGPAC6B4N5P2MDKX8V4GF9QDE1FDDDD', 'NYCDegen#420', 16.9302),
  //   createData(11, 'SP1SCEXE6PMGPAC6B4N5P2MDKX8V4GF9QDE1FNNGJ', 'MiamiDegen#123', 6.0124),
  //   createData(12, 'SP1SCEXE6PMGPAC6B4N5P2MDKX8V4GF9QDE1FAAAA', 'MiamiDegen#534', 9.7453),
  // ];

  const [highscoresLobby, setHighscoresLobby] = useState<RowData[]>();
  const onShowHighscores = async (idLobby: number) => {
    const server_highscores: ServerData[] = await fetch(link_comp + '/highscores/' + idLobby + '/lobby')
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        return data;
      });

    // Either we have good values or we are going to mark this as no highscores
    const highscores: RowData[] = areHighscoresLobby(server_highscores)
      ? server_highscores.map((x, place) => createLobbyRowData(place + 1, x.address, x.nft, x.score))
      : [createLobbyRowData(-1, 'no highscores', 'no highscores', -1)];

    setHighscoresLobby(highscores);
  };

  const onJoinLobbyBtc = () => {
    if (timeLeft.indexOf('-') !== -1) {
      return;
    }

    props.setOpenState(true);

    //@ts-ignore::next-line
    window.lnswap(
      'swap',
      'sdjoingame',
      props.accountAddress,
      props.data.price,
      contractMapping[network].contract,
      '',
      'false',
      '',
      '',
      [props.data.idLobby]
    );

    // @ts-ignore::next-line
    window.onmessage = function (e) {
      if (e.data?.target === 'lnswap' && e.data.data.status === 'triggerJoinLobby pending') {
        const txId = e.data.data.txId;
        if (txId === '') props.setLoadingState('FailedJoin');
        else {
          sendDbJoinLobby();
          console.log(
            `joined lobby ${props.data.idLobby} with btc confirmed. see on explorer: ${
              transactionUrl[network](txId).explorerUrl
            }`
          );
        }
      }
    };
  };

  if (isRacing) {
    console.log(props.data);
    return <RaceShell onClickReloadMenu={() => setIsRacing(false)} raceLobbyProps={props.data} />;
  }

  let lobbyAddressIcon: ILobbyTxId = {
    txId: props.accountAddress,
    urlType: 'explorerUrlAddress',
    imgSrc: newTabTxWhite,
    imgWidth: '15px',
  };

  return (
    <>
      {
        <div className="lobby-card" css={styleProps}>
          <div className="lobby-card-container">
            <div
              className="lobby-card-actions"
              css={css`
                background-image: url('${MapLobbiesImg[props.data.map as MapsTemp]}');
              `}
            >
              {/* <Button label={'Details'} secondary={true} dataSize={'small'} /> */}

              {props.data.status === 'checking' ? (
                <Button label={'Pending...'} dataSize={'small'} disabled={true} />
              ) : props.data.status === 'startedChecking' ? (
                <>
                  <DialogHighscores
                    rowsData={highscoresLobby}
                    onClick={() => onShowHighscores(props.data.idLobby)}
                    idLobby={props.data.idLobby}
                    label={'Highscores'}
                    secondary={true}
                    dataSize={'small'}
                  />

                  <Button
                    label={'Pending...'}
                    dataSize={'small'}
                    inactive={true}
                    success={true}
                    img={lobbyAddressIcon}
                  />
                </>
              ) : props.data.status == 'created' ? (
                <>
                  <Button
                    label={'Join'}
                    dataSize={'small'}
                    onClick={!isNegativeTime(timeLeft) ? onJoinLobby : () => null}
                    disabled={isNegativeTime(timeLeft)}
                  />
                  <Button
                    label={'Join btc'}
                    dataSize={'small'}
                    onClick={!isNegativeTime(timeLeft) ? onJoinLobbyBtc : () => null}
                    disabled={isNegativeTime(timeLeft)}
                  />
                </>
              ) : props.data.status == 'started' ? (
                <>
                  <DialogHighscores
                    rowsData={highscoresLobby}
                    onClick={() => onShowHighscores(props.data.idLobby)}
                    idLobby={props.data.idLobby}
                    label={'Highscores'}
                    secondary={true}
                    dataSize={'small'}
                  />
                  <Button
                    label={'Join'}
                    dataSize={'small'}
                    onClick={onJoinLobby}
                    disabled={isNegativeTime(timeLeft)} // todo: make it work, works with true/ false
                  />

                  <Button
                    label={'Join btc'}
                    dataSize={'small'}
                    onClick={onJoinLobbyBtc}
                    disabled={isNegativeTime(timeLeft)}
                  />
                </>
              ) : props.data.status === 'createdJoined' ? (
                <Button label={'Joined'} dataSize={'small'} disabled={true} success={true} />
              ) : props.data.status === 'createdChecking' ? (
                <Button label={'Pending...'} dataSize={'small'} inactive={true} success={true} img={lobbyAddressIcon} />
              ) : props.data.status === 'createdReadyToStart' ? (
                <Button
                  label={'Start Lobby'}
                  dataSize={'small'}
                  success={true}
                  onClick={onClickStart}
                  disabled={isNegativeTime(timeLeft)}
                />
              ) : props.data.status === 'startedReady' ? (
                <>
                  <DialogHighscores
                    rowsData={highscoresLobby}
                    onClick={() => onShowHighscores(props.data.idLobby)}
                    idLobby={props.data.idLobby}
                    label={'Highscores'}
                    secondary={true}
                    dataSize={'small'}
                  />
                  <Button label={'Race'} dataSize={'small'} onClick={onClickRace} disabled={isNegativeTime(timeLeft)} />
                </>
              ) : props.data.status === 'ended' ? (
                <>
                  <DialogHighscores
                    rowsData={highscoresLobby}
                    onClick={() => onShowHighscores(props.data.idLobby)}
                    idLobby={props.data.idLobby}
                    label={'Highscores'}
                    secondary={true}
                    dataSize={'small'}
                  />
                  <Button label={paydEndedBtnText()} dataSize={'small'} disabled={true} />
                </>
              ) : props.data.status === 'failed' ? (
                <Button label={'Failed'} dataSize={'small'} disabled={true} />
              ) : props.data.status === 'refunded' ? (
                <Button label={refundedBtnText()} dataSize={'small'} disabled={true} />
              ) : (
                ''
              )}
            </div>
            <div className="lobby-card-details">
              <LobbyTxId txId={props.data.txId} urlType={'explorerUrl'} imgSrc={newTabTx} imgWidth={'15px'} />
              <span>ID: {props.data.idLobby ? props.data.idLobby : '-'}</span>
              <span>Owner: {owner}</span>
              <span>Prize Pool: {props.data.balance} STX</span>
              <span>Players: {props.data.players || props.data.nrPlayers}</span>
              <span>Entry Fee: {props.data.price} STX</span>
              <LobbyCardTime
                createTime={props.data.createTime}
                endTime={props.data.endTime}
                status={props.data.status}
                timeLeft={timeLeft}
                setTimeLeft={setTimeLeft}
              />
            </div>
          </div>
        </div>
      }
    </>
  );
};
